enum Lifestyle {
  Minimum = "Minimum",
  Living = "Living",
  Moderate = "Moderate",
  Comfortable = "Comfortable"
}

export default Lifestyle;
